export default "__VITE_ASSET__BXG_KVil__"